<div>
  <form [formGroup]="stepFormGroup" class="step-container">
    <mat-card class="card-general">
      <mat-card-title>Anteriores Superiores</mat-card-title>
      <mat-card-content class="w-100 mt-2 d-flex flex-column gap-5">
        <div class="row w-100">
          <div class="col-12 col-lg-10">
            <div class="row mb-5 w-100 justify-content-start">
              <p class="col-4 text-start">Deseo:</p>
              <mat-radio-group aria-label="Seleciona una opción" formControlName="upperAnteriorVerticalMovementType" class="col d-flex flex-wrap gap-5 pb-4 text-border-bottom justify-content-center">
                <div class="d-flex gap-3 align-items-center" *ngFor="let item of verticalMovementTypeOptions">
                  <mat-radio-button [value]="item.value"
                                    [checked]="item.value == getControl(stepFormGroup,'upperAnteriorVerticalMovementType')" (click)="resetFormControl(stepFormGroup, 'upperAnteriorQuantity')"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
                  <div *ngIf="item.value != 0 && item.value == getControl(stepFormGroup,'upperAnteriorVerticalMovementType')">
                    <mat-form-field style="width: fit-content; height: fit-content;">
                      <input matInput type="number" min="0" formControlName="upperAnteriorQuantity">
                    </mat-form-field>
                    <span>mm</span>
                  </div>
                </div>
              </mat-radio-group>
            </div>

            <div class="row mb-5 justify-content-start" *ngIf="getControl(stepFormGroup,'levelingType')==1">
              <p style="width: fit-content;">
                Relación de bordes incisales entre centrales y laterales: dejar escalón de 
                <mat-form-field matInput style="width: fit-content;">
                  <mat-select formControlName="incisalEdgesQuantity" class="text-center">
                    <mat-option *ngFor="let item of selectNumberTenthsOfMilimeterUntil1Options" [value]="item">
                      {{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- <mat-form-field style="width: fit-content; height: fit-content;">
                  <input matInput type="number" min="0.1" max="1" [min]="0" [max]="1.0" minMax step=".1" formControlName="incisalEdgesQuantity">
                </mat-form-field> -->
                <span>mm</span>
              </p>
              <textarea maxlength="620" matInput placeholder="Ingresar comentarios de bordes incisales.." name="incisalEdgesComments" formControlName="incisalEdgesComments" style="height: 120px;"></textarea>
            </div>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-17.svg" />
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Anteriores Inferiores</mat-card-title>
      <mat-card-content class="w-100 mt-2">
        <div class="row align-items-center w-100 justify-content-start">
          <p class="col-12 col-lg-3 text-start">Deseo:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerAnteriorVerticalMovementType" class="mb-5 col-12 col-lg-7 d-flex flex-wrap gap-4">
            <div class="d-flex gap-3 align-items-center" *ngFor="let item of verticalMovementTypeOptions">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'lowerAnteriorVerticalMovementType')" (click)="resetFormControl(stepFormGroup, 'lowerAnteriorQuantity')"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
              <div *ngIf="item.value != 0 && item.value == getControl(stepFormGroup,'lowerAnteriorVerticalMovementType')">
                <mat-form-field style="width: fit-content; height: fit-content;">
                  <input matInput type="number" min=".1"formControlName="lowerAnteriorQuantity">
                </mat-form-field>
                <span>mm</span>
              </div>
            </div>
          </mat-radio-group>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-18.svg" />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Posteriores Superiores</mat-card-title>
      <mat-card-content class="w-100 mt-2">
        <div class="row w-100 align-items-center justify-content-start">
          <p class="col-12 col-lg-3 text-start">Deseo:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="upperPosteriorVerticalMovementType" class="col-12 col-lg-7 d-flex flex-wrap gap-4 mb-5">
            <div class="d-flex gap-3 align-items-center" *ngFor="let item of verticalMovementTypeOptions">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'upperPosteriorVerticalMovementType')" (click)="resetFormControl(stepFormGroup, 'upperPosteriorQuantity')"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
              <div *ngIf="item.value != 0 && item.value == getControl(stepFormGroup,'upperPosteriorVerticalMovementType')">
                <mat-form-field style="width: fit-content; height: fit-content;">
                  <input matInput type="number" min="0.1"  formControlName="upperPosteriorQuantity">
                </mat-form-field>
                <span>mm</span>
              </div>
            </div>
          </mat-radio-group>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-17.svg" />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Posteriores Inferiores</mat-card-title>
      <mat-card-content class="w-100 mt-2">
        <div class="row w-100 align-items-center justify-content-start">
          <p class="col-12 col-lg-3 text-start">Deseo:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerPosteriorVerticalMovementType" class="mb-5 col-12 col-lg-7 d-flex flex-wrap gap-4">
            <div class="d-flex gap-3 align-items-center" *ngFor="let item of verticalMovementTypeOptions">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'lowerPosteriorVerticalMovementType')" (click)="resetFormControl(stepFormGroup, 'lowerPosteriorQuantity')"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
              <div *ngIf="item.value != 0 && item.value == getControl(stepFormGroup,'lowerPosteriorVerticalMovementType')">
                <mat-form-field style="width: fit-content; height: fit-content;">
                  <input matInput type="number" min="0.1" formControlName="lowerPosteriorQuantity">
                </mat-form-field>
                <span>mm</span>
              </div>
            </div>
          </mat-radio-group>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-18.svg" />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Canto Maxilo-Mandibular</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col text-start">¿Requiere de correci&oacute;n Canto Maxilo-Mandibular?</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="requiresCorrection" class="col d-flex flex-wrap gap-4">
            <div class="row gx-4 gy-2" *ngFor="let item of booleanOptions">
              <mat-radio-button [value]="item.value"
                [checked]="item.value == getControl(stepFormGroup,'requiresCorrection')" (click)="resetFormControl(stepFormGroup, 'correctionInstructions')" class="col py-6"
              ><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
        <div class="row justify-content-center" *ngIf="getControl(stepFormGroup,'requiresCorrection')">
          <textarea maxlength="620" matInput placeholder="Indicaciones de correción..." name="correctionInstructions" formControlName="correctionInstructions" style="height: 120px;"></textarea>
        </div>
      </mat-card-content>
    </mat-card>

    <textarea maxlength="620" matInput placeholder="Ingresar comentarios..." name="secondVerticalDimensionComments" formControlName="secondVerticalDimensionComments" style="height: 120px;"></textarea>


    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Anterior</button>
      <button mat-button matStepperNext data-testid="nextStep7" class="button secondary-button" (click)="updateStepPrescription()" [disabled]="disabledButtonStages()">Guardar y Continuar <mat-icon>chevron_right</mat-icon></button>
    </div>
  </form>
</div>
